import axios from './../../function/axiosInstance'
import extract from './../../function/extract'

interface Payload {
  token: string
  reason?: string
}

export const unsubscribeEmail = async ({
  token,
  reason
}: Payload): Promise<ApiResponse> => {
  try {
    const response = await axios.post(`/unsubscribe`, { token, reason })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const getBulkWorkflowTransactionStatus = async (
  id: string
): Promise<ApiResponseV2<BulkTransactionResponse>> => {
  try {
    const response = await axios.get(`/tasks/${id}`)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
